import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  PlusOutlined,
  SyncOutlined,
  ClearOutlined,
  MailOutlined,
} from '@ant-design/icons';
import { Form, FormInstance, Modal, Tooltip } from 'antd';
import { selectCurrencyFormat, selectFormatDate } from 'app/commonRedux/appSlice';
import { useAppSelector } from 'app/hooks';
import ITVSearch from 'components/ITVSearch';
import ITVTable from 'components/ITVTable';
import MenuAction from 'components/MenuAction';
import ModalViewWorkflowByPayroll from 'features/configuration/pages/SetupWorkflowType/components/ModalViewWorkflowByPayroll';
import { notificationToast } from 'components/notificationToast';
import payrollApi from 'api/payrollApi';
import { confirmRemind } from 'features/payroll/utils/confirmRemind';
import {
  createPayRun,
  createPayroll,
  deletePayRun,
  deletePayroll,
  getPayRuns,
  remindApprovePayroll,
  updatePayRun,
  updatePayroll,
  syncHiddenPayrolls,
  cleanupOrphanPayrolls,
} from 'features/payroll/payrollAction';
import { selectPayroll } from 'features/payroll/payrollSlice';
import moment from 'moment';
import numeral from 'numeral';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import CustomButton from 'styles/buttonStyled';
import { ContainerBgWhite } from 'styles/containerBgWhite';
import { getUser } from 'utils/auth';
import { removeAccents } from 'utils/text';
import { checkPermissionCurrentUser } from '../../../ManageRequest/functionForWorkFlow';
import { PayRunModal } from './PayRunModal';
import { PayRunDetailModal } from './PayRunDetailModal';
import MaskedValueRenderer from 'components/MaskedValueRenderer';
import { Notification } from 'constants/notification';

enum MODE {
  VIEW = 'VIEW',
  ADD = 'ADD',
  UPDATE = 'UPDATE',
  VIEWWL = 'VIEWWL',
}

enum TypeEditPayroll {
  TITLE = 'title',
  USER = 'user',
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: max-content;
`;

export const PayRuns = (props: any) => {
  const { year } = props;
  const dispatch = useDispatch();
  const [sizePage, setSizePage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [mode, setMode] = useState<string>('');
  const [isPayroll, setIsPayroll] = useState<any>(null);
  const [currentItem, setCurrentItem] = useState<any>(null);
  const { t } = useTranslation(['menu', 'action', 'employee', 'timesheet', 'payroll']);
  const history = useHistory();
  const payRunData = useAppSelector(selectPayroll)?.payRunData?.result;
  const loadingPayRunData = useAppSelector(selectPayroll)?.loadingPayRunData;
  const [data, setData] = useState([]); //dataMockPayRun
  const formatDate = useAppSelector(selectFormatDate);
  const currencyFormat = useAppSelector(selectCurrencyFormat);

  useEffect(() => {
    const params = {
      year: year ? moment(year).format('YYYY') : '',
    };
    dispatch(getPayRuns(params));
  }, [year, dispatch]);

  const reformatData = (data: any) => {
    return data?.map((item: any) => ({
      ...item,
      children: item?.payrollDetails?.map((i: any) => ({
        ...i,
        id: `${item?.id}_${i?.id}`,
        period: item?.period,
      })),
    }));
  };

  useEffect(() => {
    if (payRunData) setData(reformatData(payRunData));
  }, [payRunData]);
  const [formView] = Form.useForm();

  const MENU = [
    {
      name: t('payroll:addNewPayRun'),
      icon: <PlusOutlined />,
      handleClick: (value: any) => {
        setMode(MODE.ADD);
        setIsPayroll(value);
      },
    },
    {
      name: t('payroll:editPayroll'),
      width: 100,
      minWidth: 100,
      icon: <EditOutlined style={{ color: '#F1592A' }} />,
      handleClick: (data: any) => {
        setCurrentItem(data);
        setMode(MODE.UPDATE);
      },
    },
    {
      name: t('action:delete'),
      type: 'delete',
      icon: <DeleteOutlined />,
      handleClick: (data: any) => {
        const groupId = data?.id?.toString().includes('_') ? getGroupId(data?.id) : data?.id;
        dispatch(
          deletePayRun({
            id: groupId,
            callBack: () =>
              dispatch(
                getPayRuns({
                  year: year ? moment(year).format('YYYY') : '',
                }),
              ),
          }),
        );
      },
    },
  ];

  const cutStringCharacter = (string: string) => {
    let arr = string?.split('_');
    return arr[1];
  };

  const getGroupId = (string: string) => {
    let arr = string?.split('_');
    return arr[0];
  };

  const handleResendFromList = async (record: any) => {
    const id = cutStringCharacter(record?.id);
    try {
      const res: any = await payrollApi.getApprovalProgress(id as string);
      const progress = res?.data;
      const remindable = (progress?.steps || []).filter(
        (s: any) => s.state === 'current' && s.canRemind,
      );
      if (!remindable.length) {
        const waiting = (progress?.steps || []).find(
          (s: any) => s.state === 'current' && s.remindAvailableAt,
        );
        notificationToast(
          Notification.Type.Warning,
          waiting
            ? t('payroll:resend_wait', { time: moment(waiting.remindAvailableAt).format('HH:mm') })
            : t('payroll:nothing_to_remind'),
          Notification.Duration._3s,
        );
        return;
      }
      confirmRemind(t, progress, undefined, () =>
        dispatch(remindApprovePayroll({ id: id as string })),
      );
    } catch (e) {
      // interceptor đã toast
    }
  };

  const MENU_CHILD = [
    {
      name: t('timesheet:View_Detail'),
      icon: <EyeOutlined style={{ color: '#1890FF' }} />,
      checkDisabled: (record: any) =>
        !checkPermissionCurrentUser(record?.workflowDetails, 'view', record?.status, getUser()?.id),
      handleClick: (value: any) => {
        history.push(`/payroll/pay-runs/detail/${cutStringCharacter(value?.id)}`);
      },
    },
    {
      name: t('payroll:viewWorkflowByPayroll'),
      icon: <EyeOutlined style={{ color: '#1890FF' }} />,
      checkDisabled: (record: any) =>
        !checkPermissionCurrentUser(record?.workflowDetails, 'view', record?.status, getUser()?.id),
      handleClick: (value: any) => {
        setCurrentItem(value);
        setMode(MODE.VIEWWL);
      },
    },
    {
      name: t('payroll:resend_email_menu'),
      icon: <MailOutlined style={{ color: '#1890FF' }} />,
      checkDisabled: (record: any) => ['draft', 'close', 'canceled'].includes(record?.status),
      handleClick: (value: any) => handleResendFromList(value),
    },
    {
      name: t('payroll:editPayRun'),
      width: 100,
      minWidth: 100,
      checkDisabled: (record: any) =>
        !checkPermissionCurrentUser(record?.workflowDetails, 'edit', record?.status, getUser()?.id),
      icon: <EditOutlined style={{ color: '#F1592A' }} />,
      handleClick: (data: any) => {
        setCurrentItem(data);
        setIsPayroll(data);
        setMode(MODE.UPDATE);
      },
    },
    {
      name: t('action:delete'),
      type: 'delete',
      checkDisabled: (record: any) =>
        !checkPermissionCurrentUser(
          record?.workflowDetails,
          'delete',
          record?.status,
          getUser()?.id,
        ),
      icon: <DeleteOutlined />,
      handleClick: (data: any) => {
        dispatch(
          deletePayroll({
            id: cutStringCharacter(data?.id),
            callBack: () => {
              dispatch(
                getPayRuns({
                  year: year ? moment(year).format('YYYY') : '',
                }),
              );
            },
          }),
        );
      },
    },
  ];

  const handleShowMenu = (record: any) => {
    return record?.status ? MENU_CHILD : MENU;
  };
  const COLUMNS: any = [
    {
      title: t('payroll:name'),
      dataIndex: 'name',
      key: 'name',
      width: 100,
      minWidth: 100,
      ellipsis: true,
      align: 'left',
    },
    {
      title: t('payroll:payPeriod'),
      dataIndex: 'period',
      key: 'period',
      align: 'left',
      width: 60,
      minWidth: 60,
    },
    {
      title: t('payroll:timeRange'),
      dataIndex: 'timeRange',
      key: 'timeRange',
      align: 'left',
      width: 100,
      minWidth: 100,
      render: function (text: any, record: any, index: any) {
        return record?.startDate && record?.endDate
          ? `${moment(record?.startDate).format(formatDate)} - ${moment(record?.endDate).format(
              formatDate,
            )}`
          : '';
      },
    },
    {
      title: t('payroll:payDate'),
      dataIndex: 'payDate',
      key: 'payDate',
      align: 'left',
      width: 100,
      minWidth: 100,
      render: function (text: any, record: any, index: any) {
        return record?.paidDate ? `${moment(record?.paidDate).format(formatDate)}` : '';
      },
    },
    {
      title: t('payroll:description'),
      dataIndex: 'description',
      key: 'description',
      align: 'left',
      width: 100,
      minWidth: 100,
      ellipsis: true,
    },
    {
      title: t('payroll:status'),
      dataIndex: 'status',
      key: 'status',
      align: 'left',
      width: 100,
      minWidth: 100,
    },
    {
      title: t('payroll:totalCompanyCost'),
      dataIndex: 'totalCompanyCost',
      key: 'totalCompanyCost',
      align: 'right',
      width: 100,
      minWidth: 100,
      render: function (text: any, record: any, index: any) {
        return <MaskedValueRenderer value={text} />;
      },
    },
    {
      title: t('payroll:totalNetPay'),
      dataIndex: 'totalReceiveSalary',
      key: 'totalReceiveSalary',
      align: 'right',
      width: 100,
      minWidth: 100,
      render: function (text: any, record: any, index: any) {
        return <MaskedValueRenderer value={text} />;
      },
    },
    {
      title: t('employee:employee_information_fields.action'),
      dataIndex: 'action',
      align: 'center',
      key: 'action',
      width: 60,
      minWidth: 60,
      render: function (text: any, record: any, index: any) {
        return <MenuAction menu={handleShowMenu(record)} data={record} />;
      },
    },
  ];

  const addNewPayRun = (form: FormInstance<any>, handleClose: any) => {
    form.validateFields().then((value: any) => {
      const body = {
        period: value?.payPeriod ? moment(value?.payPeriod, 'YYYY-MM').format('YYYY-MM') : '',
        name: value?.name || '',
        description: value?.description || '',
      };
      dispatch(
        createPayRun({
          body,
          callBack: () => {
            dispatch(
              getPayRuns({
                year: year ? moment(year).format('YYYY') : '',
              }),
            );
            handleClose();
          },
        }),
      );
    });
  };

  const updatePayrun = (form: FormInstance<any>, id: any, handleClose: any) => {
    form.validateFields().then((value: any) => {
      const body = {
        period: value?.payPeriod ? moment(value?.payPeriod, 'YYYY-MM').format('YYYY-MM') : '',
        name: value?.name || '',
        description: value?.description || '',
      };
      dispatch(
        updatePayRun({
          body,
          id,
          callBack: () => {
            dispatch(
              getPayRuns({
                year: year ? moment(year).format('YYYY') : '',
              }),
            );
            handleClose();
          },
        }),
      );
    });
  };

  const createPayRoll = (form: FormInstance<any>, users: any, handleClose: any) => {
    form.validateFields().then((value: any) => {
      // Validate users array is not empty
      if (!users || !Array.isArray(users) || users.length === 0) {
        notificationToast(
          Notification.Type.Error,
          t('payroll:noMembersSelected') ||
            'Please select at least one member to add to the pay run.',
          3,
        );
        return;
      }

      // Map users to userIds and filter out any invalid entries
      const userIds = users
        .map((item: any) => item?.id)
        .filter((id: any) => id != null && id !== '');

      if (userIds.length === 0) {
        notificationToast(
          Notification.Type.Error,
          t('payroll:noMembersSelected') ||
            'Please select at least one member to add to the pay run.',
          3,
        );
        return;
      }

      const body = {
        name: value?.name || '',
        payRunType: value?.payRunType || undefined,
        description: value?.description || '',
        startDate: value?.timeRange[0] ? moment(value?.timeRange[0]).format('YYYY-MM-DD') : null,
        endDate: value?.timeRange[1] ? moment(value?.timeRange[1]).format('YYYY-MM-DD') : null,
        paidDate: value?.payDate ? moment(value?.payDate).format('YYYY-MM-DD') : null,
        payrollGroupId: isPayroll?.id,
        workFlowTypeId: value?.workflow || '',
        userIds: userIds,
      };

      // Store initial payRunData for comparison
      const initialPayRunCount =
        payRunData?.reduce((total: number, group: any) => {
          return total + (group?.payrollDetails?.length || 0);
        }, 0) || 0;

      dispatch(
        createPayroll({
          body,
          callBack: (res) => {
            // Handle error case - stop polling if creation failed
            if (res?.statusCode !== 201) {
              notificationToast(
                Notification.Type.Error,
                res?.message ||
                  t('payroll:errorCreatingPayroll') ||
                  'Failed to create pay run. Please try again.',
                5,
              );
              return;
            }

            if (res?.statusCode === 201) {
              handleClose();

              // Get the created pay run ID from response
              const createdPayRunId = res?.data?.id;
              const expectedPayrollGroupId = body.payrollGroupId;
              const expectedPayRunName = body.name?.replace('Payroll', 'Pay Run') || body.name;

              // Show processing notification
              notificationToast(
                Notification.Type.Info,
                t('payroll:processingPayroll'),
                0, // Don't auto close
              );

              // Optimized polling with exponential backoff
              let retryCount = 0;
              const maxRetries = 25; // Maximum 25 retries (~50 seconds)
              let baseInterval = 2000; // Start with 2 seconds
              let consecutiveNoChangeCount = 0;
              const maxConsecutiveNoChange = 8; // Stop if no change after 8 consecutive polls

              const pollPayRunData = () => {
                retryCount++;

                // Check if we've exceeded max retries
                if (retryCount > maxRetries) {
                  notificationToast(
                    Notification.Type.Warning,
                    t('payroll:payrollProcessingTimeout') ||
                      'Payroll is being processed. Please refresh the page later.',
                    5,
                  );
                  return;
                }

                // Exponential backoff: increase interval gradually (max 8 seconds)
                const currentInterval = Math.min(
                  baseInterval * Math.pow(1.15, retryCount - 1),
                  8000,
                );

                dispatch(
                  getPayRuns({
                    year: year ? moment(year).format('YYYY') : '',
                  }),
                )
                  .then((action) => {
                    if (action.payload?.data?.result) {
                      const newPayRunData = action.payload.data.result;

                      // Find the payroll group we're looking for
                      const targetGroup = newPayRunData?.find(
                        (group: any) => group?.id === expectedPayrollGroupId,
                      );

                      let foundNewPayRun = false;

                      if (targetGroup && targetGroup.payrollDetails) {
                        // Method 1: Find by ID if we have it
                        if (createdPayRunId) {
                          foundNewPayRun = targetGroup.payrollDetails.some(
                            (detail: any) => detail?.id === createdPayRunId,
                          );
                        }

                        // Method 2: Find by name if ID not available
                        if (!foundNewPayRun && expectedPayRunName) {
                          foundNewPayRun = targetGroup.payrollDetails.some(
                            (detail: any) => detail?.name === expectedPayRunName,
                          );
                        }

                        // Method 3: Check if count increased
                        if (!foundNewPayRun) {
                          const newPayRunCount = targetGroup.payrollDetails.length || 0;
                          if (newPayRunCount > initialPayRunCount) {
                            foundNewPayRun = true;
                          }
                        }
                      }

                      if (foundNewPayRun) {
                        // Show success notification
                        notificationToast(
                          'success',
                          t('payroll:payrollCreated'),
                          3, // Close after 3 seconds
                        );
                        // Refresh data one more time to ensure UI is updated
                        dispatch(
                          getPayRuns({
                            year: year ? moment(year).format('YYYY') : '',
                          }),
                        );
                      } else {
                        consecutiveNoChangeCount++;

                        // Stop if no change after several consecutive polls
                        if (consecutiveNoChangeCount >= maxConsecutiveNoChange) {
                          notificationToast(
                            Notification.Type.Info,
                            t('payroll:payrollProcessing') ||
                              'Payroll is being processed in the background. Please refresh the page later to see the result.',
                            5,
                          );
                          return;
                        }

                        // Continue polling with exponential backoff
                        setTimeout(pollPayRunData, currentInterval);
                      }
                    } else {
                      consecutiveNoChangeCount++;
                      if (consecutiveNoChangeCount >= maxConsecutiveNoChange) {
                        notificationToast(
                          Notification.Type.Info,
                          t('payroll:payrollProcessing') ||
                            'Payroll is being processed in the background. Please refresh the page later to see the result.',
                          5,
                        );
                        return;
                      }
                      setTimeout(pollPayRunData, currentInterval);
                    }
                  })
                  .catch((error) => {
                    // Stop polling on error and show error message
                    console.error('Error polling pay run data:', error);
                    notificationToast(
                      Notification.Type.Error,
                      t('payroll:errorLoadingPayroll') ||
                        'Error loading payroll data. Please refresh the page.',
                      5,
                    );
                  });
              };

              // Start polling after a short delay to allow backend to process
              setTimeout(pollPayRunData, 1500);
            }
          },
        }),
      );
    });
  };

  const updatePayRoll = (form: FormInstance<any>, id: any, handleClose: any) => {
    form.validateFields().then((value: any) => {
      const body = {
        name: value?.name || '',
        description: value?.description || '',
        startDate: value?.timeRange[0] ? moment(value?.timeRange[0]).format('YYYY-MM-DD') : null,
        endDate: value?.timeRange[1] ? moment(value?.timeRange[1]).format('YYYY-MM-DD') : null,
        paidDate: value?.payDate ? moment(value?.payDate).format('YYYY-MM-DD') : null,
        workFlowTypeId: value?.workflow || '',
        type: TypeEditPayroll.TITLE,
      };
      dispatch(
        updatePayroll({
          id: cutStringCharacter(id),
          body,
          callBack: () => {
            dispatch(
              getPayRuns({
                year: year ? moment(year).format('YYYY') : '',
              }),
            );
            handleClose();
          },
        }),
      );
    });
  };

  const handleSearch = (value: string) => {
    const text = value && removeAccents(value.toLowerCase());
    if (text) {
      const temp = payRunData?.filter((item: any) => {
        return item?.name && removeAccents(item?.name?.toLowerCase()).includes(text);
      });
      setData(reformatData(temp));
    } else {
      setData(reformatData(payRunData));
    }
  };

  // Handle Sync Hidden Payrolls
  const handleSyncHiddenPayrolls = () => {
    Modal.confirm({
      title: t('payroll:syncHiddenPayrollsTitle') || 'Sync Hidden Payrolls',
      content:
        t('payroll:syncHiddenPayrollsContent') ||
        'This will find and sync payrolls that exist in database but are not displayed on UI. Continue?',
      okText: t('action:confirm') || 'Confirm',
      cancelText: t('action:cancel') || 'Cancel',
      onOk: () => {
        const params = {
          year: year ? moment(year).format('YYYY') : moment().format('YYYY'),
          callBack: (response: any) => {
            if (response?.statusCode === 201 || response?.data) {
              const result = response?.data;
              notificationToast(
                Notification.Type.Success,
                `${t('payroll:syncSuccess') || 'Sync completed!'} ${
                  result?.syncedCount || 0
                } payrolls synced.`,
                5,
              );
              // Refresh data
              dispatch(getPayRuns({ year: year ? moment(year).format('YYYY') : '' }));

              // Show orphan records if any
              if (result?.orphanDeletedGroups?.length > 0) {
                Modal.warning({
                  title: t('payroll:orphanRecordsFound') || 'Orphan Records Found',
                  content: (
                    <div>
                      <p>
                        {t('payroll:orphanRecordsMessage') ||
                          'The following deleted records may cause duplicate errors when creating new payrolls:'}
                      </p>
                      <ul>
                        {result.orphanDeletedGroups.map((item: any) => (
                          <li key={item.id}>
                            {item.period} - {item.name}
                          </li>
                        ))}
                      </ul>
                      <p>
                        {t('payroll:useCleanupButton') ||
                          'Use the Cleanup button to remove these records.'}
                      </p>
                    </div>
                  ),
                });
              }
            } else {
              notificationToast(
                Notification.Type.Error,
                response?.message || t('payroll:syncFailed') || 'Sync failed!',
                5,
              );
            }
          },
        };
        dispatch(syncHiddenPayrolls(params));
      },
    });
  };

  // Handle Cleanup Orphan Payrolls
  const handleCleanupOrphanPayrolls = () => {
    Modal.confirm({
      title: t('payroll:cleanupOrphanTitle') || 'Cleanup Orphan Records',
      content:
        t('payroll:cleanupOrphanContent') ||
        'This will permanently delete orphan records that cause duplicate errors. This action cannot be undone. Continue?',
      okText: t('action:confirm') || 'Confirm',
      cancelText: t('action:cancel') || 'Cancel',
      okButtonProps: { danger: true },
      onOk: () => {
        const params = {
          year: year ? moment(year).format('YYYY') : moment().format('YYYY'),
          callBack: (response: any) => {
            if (response?.statusCode === 200 || response?.data) {
              const result = response?.data;
              notificationToast(
                Notification.Type.Success,
                result?.message ||
                  `${t('payroll:cleanupSuccess') || 'Cleanup completed!'} ${
                    result?.cleanedCount || 0
                  } records removed.`,
                5,
              );
              // Refresh data
              dispatch(getPayRuns({ year: year ? moment(year).format('YYYY') : '' }));
            } else {
              notificationToast(
                Notification.Type.Error,
                response?.message || t('payroll:cleanupFailed') || 'Cleanup failed!',
                5,
              );
            }
          },
        };
        dispatch(cleanupOrphanPayrolls(params));
      },
    });
  };

  return (
    <Container>
      <ContainerBgWhite>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
          <ITVSearch handleSearch={handleSearch} />
          <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
            <Tooltip title={t('payroll:syncHiddenPayrolls') || 'Sync hidden payrolls'}>
              <CustomButton
                style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
                onClick={() => handleSyncHiddenPayrolls()}
              >
                <SyncOutlined /> {t('payroll:sync') || 'Sync'}
              </CustomButton>
            </Tooltip>
            <Tooltip title={t('payroll:cleanupOrphanPayrolls') || 'Cleanup orphan records'}>
              <CustomButton
                style={{ backgroundColor: '#faad14', borderColor: '#faad14' }}
                onClick={() => handleCleanupOrphanPayrolls()}
              >
                <ClearOutlined /> {t('payroll:cleanup') || 'Cleanup'}
              </CustomButton>
            </Tooltip>
            <CustomButton
              onClick={() => {
                setMode(MODE.ADD);
              }}
            >
              <PlusOutlined /> {t('payroll:addNew')}
            </CustomButton>
          </div>
        </div>
        <ITVTable
          loading={loadingPayRunData}
          isRowSelect={false}
          columns={COLUMNS}
          data={data}
          width={1080}
          height={550}
          setOffset={setCurrentPage}
          offset={currentPage}
          setLimit={setSizePage}
          limit={sizePage}
        />
      </ContainerBgWhite>
      {isPayroll ? (
        <PayRunDetailModal
          mode={mode}
          setMode={setMode}
          currentItem={currentItem}
          isPayroll={isPayroll}
          setIsPayroll={setIsPayroll}
          setCurrentItem={setCurrentItem}
          callBack={(form: any, users: any, handleClose: any, id?: any) => {
            mode === MODE.ADD
              ? createPayRoll(form, users, handleClose)
              : updatePayRoll(form, id, handleClose);
          }}
        />
      ) : (
        (mode === MODE.ADD || mode === MODE.UPDATE) && (
          <PayRunModal
            mode={mode}
            setMode={setMode}
            currentItem={currentItem}
            setCurrentItem={setCurrentItem}
            setIsPayroll={setIsPayroll}
            callBack={(form: any, handleClose: any, id?: any) => {
              mode === MODE.ADD
                ? addNewPayRun(form, handleClose)
                : updatePayrun(form, id, handleClose);
              /*dispatch get all pay runs*/
            }}
          />
        )
      )}
      {mode === MODE.VIEWWL && (
        <ModalViewWorkflowByPayroll
          currentItem={currentItem}
          form={formView}
          // onSave={onSave}
          mode={mode}
          setMode={setMode}
          // idRecord={idRecord}
          // setCurrentItem={setCurrentItem}
        />
      )}
    </Container>
  );
};
